import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categoryLabel } from './categoryLabel';

// `raw` = render categoryName exactly as given, skipping the categoryNames
// lookup. Set it for curriculum-tree nodes: those names are official ministry
// wording already in the country's own language, and an English-language
// jurisdiction (LCA "Mathematics", JAM "Science") would otherwise collide with
// a categoryNames key and get re-translated into the UI locale.
export default function PrintablesBreadcrumb({ categoryName, onBackToLanding, raw = false }) {
  const { t } = useTranslation('printables');
  const [hovered, setHovered] = useState(false);

  return (
    <div style={{
      display: 'flex', alignItems: 'baseline', gap: 6,
    }}>
      <span
        onClick={onBackToLanding}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          fontSize: '1rem', fontWeight: 800,
          color: hovered ? 'rgba(255,144,112,1)' : 'rgba(232,104,72,0.8)',
          cursor: 'pointer',
          textDecoration: hovered ? 'underline' : 'none',
          transition: 'color 0.15s ease',
        }}
      >
        {t('breadcrumb.printables')}
      </span>
      <span style={{ fontSize: '1rem', color: 'rgba(27,37,80,0.4)' }}>›</span>
      <span style={{
        fontSize: '1rem', fontWeight: 800,
        color: 'rgba(27,37,80,0.522)',
        overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
      }}>
        {categoryName
          ? (raw ? categoryName : categoryLabel(t, categoryName))
          : t('breadcrumb.allPosters')}
      </span>
    </div>
  );
}
